import {
  Box
} from '@material-ui/core';
import moment from 'moment';
import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showLoading } from 'src/features/videoSlice';
import VehicleTablecell from '../tables/VehicleTablecell';
import { TableVirtuoso } from 'react-virtuoso';
import { titleTableHeader } from '../tables/constance';

// Man streaming
const VehicleTable = ({ listVehicle }) => {
  const dispatch = useDispatch();
  const [rowActive, setRowActive] = useState(null);
  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);

  const vehicleMapBySerial = useMemo(() => {
    const map = new Map();
    for (const vehicle of listVehicle) {
      map.set(vehicle.device_serial, vehicle);
    }
    return map;
  }, [listVehicle]);

  const findVehicle = () => {
    return vehicleMapBySerial.get(deviceSerial);
  };

  const vehicleSelected = findVehicle();

  useEffect(() => {
    if (vehicleSelected) {
      setRowActive(vehicleSelected.device_id);
    }
  }, [vehicleSelected]);

  const handleRowClick = vehicle => {
    const vehicleId = vehicle.device_id;
    if (vehicleId) {
      setRowActive(prev => (prev === vehicleId ? null : vehicleId));
    }
    dispatch(showLoading({ device_serial: vehicle.device_serial }));
  };

  return (
    <>
      <TableVirtuoso
        style={{ height: '96%' }}
        data={listVehicle}
        components={{
          Table: props => (
            <table
              {...props}
              style={{
                ...props.style,
                borderCollapse: 'collapse',
                border: '1px solid rgba(60, 64, 67, 0.15)',
                backgroundColor: '#f5f5f5'
              }}
            />
          ),
          TableRow: ({ item, ...props }) => {
            const isActive = item.device_id === rowActive;
            return (
              <tr
                {...props}
                onClick={() => handleRowClick(item, props.index)}
                style={{
                  ...props.style,
                  borderBottom: '1px solid rgba(60, 64, 67, 0.15)',
                  cursor: 'pointer',
                  backgroundColor: isActive ? '#ffe4e1' : 'transparent'
                }}
              />
            );
          }
        }}
        fixedHeaderContent={() => (
          <tr>
            {titleTableHeader.map(title => {
              return (
                <th
                  style={{
                    width: 116,
                    border: '1px solid rgba(60, 64, 67, 0.15)',
                    padding: '12px 5px',
                    background: '#d9042f',
                    color: '#FFFFFF',
                    fontSize: '12px',
                    fontWeight: 500
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    {title.name}
                  </span>
                </th>
              );
            })}
          </tr>
        )}
        itemContent={(index, vehicle) => (
          <>
            <td style={{ width: 117, height: 38 }}>
              <VehicleTablecell row={vehicle} index={index} />
            </td>
            <td style={{ width: 117, height: 38 }}>
              {vehicle.debt ? (
                <span
                  align="center"
                  style={{ color: '#D9042F', fontSize: '12px' }}
                >
                  Hết hạn gói dịch vụ
                </span>
              ) : (
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '12px'
                  }}
                >
                  {Math.floor(vehicle.speed_gps) || 0}
                </span>
              )}
            </td>
            <td style={{ width: 117, height: 38 }}>
              {vehicle.debt ? (
                <span
                  align="center"
                  style={{ color: '#D9042F', fontSize: '12px' }}
                ></span>
              ) : (
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <span
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '12px'
                    }}
                  >
                    {vehicle
                      ? moment.unix(vehicle.created_at).format('DD/MM HH:mm:ss')
                      : '--'}
                  </span>
                </Box>
              )}
            </td>
          </>
        )}
      />
    </>
  );
};

export default React.memo(VehicleTable);
